import { render, staticRenderFns } from "./RelatedEventItem.vue?vue&type=template&id=441e9bb1&"
import script from "./RelatedEventItem.vue?vue&type=script&lang=ts&"
export * from "./RelatedEventItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('441e9bb1')) {
      api.createRecord('441e9bb1', component.options)
    } else {
      api.reload('441e9bb1', component.options)
    }
    module.hot.accept("./RelatedEventItem.vue?vue&type=template&id=441e9bb1&", function () {
      api.rerender('441e9bb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/related/RelatedEventItem.vue"
export default component.exports